import { LocaleState } from './locale.state';
import { createFeatureSelector } from '@ngrx/store';

export const selectLocales = createFeatureSelector<LocaleState>('applicationLocale');
